import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateShopper: {
    defaultMessage: 'Rate Shopper',
    description: 'Name displayed for rate shopper recommendations in cost review',
    id: 'czEqz7',
  },
});
